// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ot-z","tooltipWrapper":"Pt-z","icon":"Qt-z","tooltip":"Rt-z","content":"St-z"};